module.exports = __webpack_public_path__ + "static/media/plp-existing-account-login-mobile.a1980732.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/plp-existing-account-login-mobile.jpg
// module id = 454
// module chunks = 0